/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request shape for skipping a global filter, or one line of it, on this entity. Deliberately NOT the response schema — `excludedBy` and `excludedAt` are stamped server-side, so a request schema carrying them would force clients to supply (and let them forge) their own audit trail.
 * @export
 * @interface GlobalFilterExclusionInput
 */
export interface GlobalFilterExclusionInput {
    /**
     * EventPipelineFilter _id to skip. 24-character hex.
     * @type {string}
     * @memberof GlobalFilterExclusionInput
     */
    filterId: string;
    /**
     * Omit to skip the whole rule. Set to a line's conditionId to skip only that line.
     * @type {string}
     * @memberof GlobalFilterExclusionInput
     */
    conditionId?: string;
    /**
     * Why this is being skipped here. Required and non-empty after trim.
     * @type {string}
     * @memberof GlobalFilterExclusionInput
     */
    reason: string;
    /**
     * Optional absolute epoch ms. Omit for a skip that lasts as long as the competition does.
     * @type {number}
     * @memberof GlobalFilterExclusionInput
     */
    expiresAt?: number;
}

/**
 * Check if a given object implements the GlobalFilterExclusionInput interface.
 */
export function instanceOfGlobalFilterExclusionInput(value: object): value is GlobalFilterExclusionInput {
    if (!('filterId' in value) || value['filterId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function GlobalFilterExclusionInputFromJSON(json: any): GlobalFilterExclusionInput {
    return GlobalFilterExclusionInputFromJSONTyped(json, false);
}

export function GlobalFilterExclusionInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterExclusionInput {
    if (json == null) {
        return json;
    }
    return {
        
        'filterId': json['filterId'],
        'conditionId': json['conditionId'] == null ? undefined : json['conditionId'],
        'reason': json['reason'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
    };
}

export function GlobalFilterExclusionInputToJSON(json: any): GlobalFilterExclusionInput {
    return GlobalFilterExclusionInputToJSONTyped(json, false);
}

export function GlobalFilterExclusionInputToJSONTyped(value?: GlobalFilterExclusionInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filterId': value['filterId'],
        'conditionId': value['conditionId'],
        'reason': value['reason'],
        'expiresAt': value['expiresAt'],
    };
}

